<template>
  <div
    class="modal fade"
    :id="modal_id"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
    :aria-labelledby="modal_id"
    aria-hidden="true"
  >
    <div :class="`modal-dialog modal-${size === 'sm' || size === 'md' || size === 'lg' ? size : 'xl'}`">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <slot name="title"></slot>
          </h5>
          <button
            type="button"
            class="close"
            @click="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modal_id: {
      type: String,
      default: 'genericModal'
    },
    size: String
  },
  methods: {
    close() {
      this.$listeners.close && this.$listeners.close()
      $(`#${this.modal_id}`).modal('hide')
    }
  }
}
</script>

<style scoped>
</style>
